"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var storage_1 = require("./storage");
exports.tasksRepository = storage_1.default.statefulItemsRepository("tasks");



//////////////////
// WEBPACK FOOTER
// ./src/infra/tasks.ts
// module id = 604
// module chunks = 0